import * as React from "react";
import Layout from "./Layout";
import { Container, Link, Typography } from "@mui/material";
import Results from "./Results";

const RamzovaPage = () => {
    return (
        <Layout>
            <Container maxWidth={"md"}>
                <Typography component="h1" variant="h2">
                    Nahoru i dolů s cílem na Ramzové
                </Typography>
                <Typography variant={"h4"} component={"h2"} gutterBottom>
                    2. segment - červenec
                </Typography>
                <ul>
                    <li>
                        <Link href={"https://www.strava.com/segments/24693300"}>
                            Segment na webu STRAVA
                        </Link>
                    </li>
                    <li>
                        <Link href={"https://www.relive.cc/view/vYvE9NW3VGv"}>
                            Video ukázka
                        </Link>
                    </li>
                </ul>
                <Typography gutterBottom>
                    Už tu máme 2. díl našeho běžeckého seriálu. Máte k dispozici
                    všech 744 hodin v 7. měsíci roku. Je jen na Vás kdy si
                    vyzkoušíte tentokrát běh plný přírody a krásné obce
                    Ostružná. Může to být Vaše jediná účast, nebo naopak 2.
                    příděl bodů do celkového hodnocení seriálu. Takže není na co
                    čekat. Připrav se a hurá na to!
                </Typography>

                <ul>
                    <li>
                        START – před volným prostorem obecního úřadu Ostružná, v
                        místě kde je možné vyjet na hlavní cestu. Start jsme
                        koncipovali na úrovni značky – „dej přednost v jízdě“ a
                        na to nezapomeňte!
                    </li>
                    <li>
                        Vydáte se směrem ke SKILANDU – po chodníku podél cesty.
                        Brzy Vás však čeká přeběh přes hlavní cestu a následně
                        pokračujete obcí po Moravské stezce. 585 metrů od startu
                        Vás čeká odbočení vlevo a pokračujete po stezce 6207.
                        Zde začínáte stoupat a čeká Vás delší výběh. Dostanete
                        se až na křižovatku s modrou turistickou značkou – tedy
                        bod „Nad pěchotním srubem“. Za sebou budete mít 1,7 km a
                        stále Vás čeká ještě velká porce stoupání (polovina). Po
                        modré doběhnete na rozcestí „Nad Dobrou vodou“. Zde se
                        již dáte doleva - ano hurá již z kopce po červené
                        turistické až do areálu Ramzová.
                    </li>
                    <li>
                        CÍL – proběhnete areálem Skiareálu Bonera, čeká Vás
                        asfaltový závěr s cílem u vzrostlých smrků se značkami
                        červené a zelené turistické. Na dohled již máte hlavní
                        cestu, kterou můžete po doběhnutí využití pro návrat na
                        start celého segmentu.
                    </li>
                </ul>
                <Results segmentId={"3-2-24693300"} />
            </Container>
        </Layout>
    );
};

export default RamzovaPage;
